import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    t,
    language,
    setLanguage
  } = useLanguage();
  const closeMenu = () => setIsOpen(false);
  return <nav className="bg-black/95 backdrop-blur-md border-b border-gray-800 sticky top-0 z-50">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/lovable-uploads/2ace17f0-675e-4e33-b1ab-a5556c985f54.png" alt="Mike Foto Logo" className="h-16 w-auto" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300">
              Αρχική
            </Link>
            <Link to="/services" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300">
              {t('nav.services')}
            </Link>
            <Link to="/consulting" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300">
              1:1 Συμβουλευτική
            </Link>
            <Link to="/work" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300">
              Projects
            </Link>
            
            <Link to="/contact" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300">
              {t('nav.contact')}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="md:hidden bg-black border-t border-gray-800">
            <div className="flex flex-col space-y-2 py-4">
              <Link to="/" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                Αρχική
              </Link>
              <Link to="/about" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                {t('nav.about')}
              </Link>
              <Link to="/services" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                {t('nav.services')}
              </Link>
              <Link to="/consulting" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                1:1 Συμβουλευτική
              </Link>
              <Link to="/work" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                Projects
              </Link>
              <a href="https://www.alphaclique.gr/" target="_blank" rel="noopener noreferrer" className="text-yellow-400 text-sm font-medium hover:text-yellow-300 transition-colors duration-300 py-2" onClick={closeMenu}>
                Academy
              </a>
              <Link to="/contact" className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2" onClick={closeMenu}>
                {t('nav.contact')}
              </Link>
              <button onClick={() => {
            setLanguage(language === 'gr' ? 'en' : 'gr');
            closeMenu();
          }} className="text-white text-sm font-medium hover:text-brand transition-colors duration-300 py-2 text-left">
                {t('nav.language')}
              </button>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;